import React from "react";
import "../Partnership/partner.scss";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

// Import fallback images

import partnerFallback from "../../assests/Partnership/octa.jpg";
import defaultImage from "../../assests/Partnership/partnership2.jpg";

const Partner = ({ data }) => {
  // Fallback data if API data is unavailable
  const partnerdata = {
    section_title: "Partnerships",
    title: "Industry Leading IDAM Solutions:",
    title_content: `Establishing a Comprehensive Defense Strategy: Empowering and protecting premier organizations with an integrated platform. 
    Simplify access policy management, clearly define group memberships, and seamlessly enforce security protocols.`,
    title_2: "Security and Compliance Solutions",
    title_2_content: "Fortify Your Digital Perimeter...",
    image: defaultImage,
    logos: [partnerFallback, partnerFallback, partnerFallback],
    downlogos: [partnerFallback, partnerFallback],
  };

  // Destructure data with fallback to partnerdata
  const {
    section_title,
    title,
    title_content,
    title_2,
    title_2_content,
    image,
    logos = [],
    downlogos = [],
  } = data?.Home_partnership || partnerdata;

  // Get API Base URL from environment
  const apiBaseUrl = process.env.REACT_APP_API;

  // Function to format image URLs correctly
  const formatUrl = (path) => {
    if (!path) return "/fallback/image.jpg";
    return `${apiBaseUrl.replace(/\/$/, "")}/${path.replace(/^\//, "")}`;
  };

  // Format images
  const fullImage = formatUrl(image);
  const formattedLogos = logos.map(formatUrl);
  const formattedDownLogos = downlogos.map(formatUrl);

  return (
    <section className="cloud_full">
      <Container>
        <Row className="align-items-center">
          {/* Left Column */}
          <Col md={12} sm={12} lg={6}>
            <div className="cloud_cnt">
              <p className="desc">{section_title || "Partnerships"}</p>

              {/* Industry Leading IDAM Solutions */}
              <p className="partner-title">
                <b>{title || "Industry Leading IDAM Solutions:"}</b>
              </p>
              <p className="sub_desc">{title_content}</p>

              {/* Logos for Industry Leading IDAM Solutions */}
              <div className="list partner-images">
                {formattedLogos.map((logo, index) => (
                  <div key={index} className={`para partner-${index + 1}`}>
                    <img
                      src={logo}
                      alt={`Partner ${index + 1}`}
                      className="partner-image"
                      onError={(e) => (e.target.src = "/fallback/image.jpg")}
                    />
                  </div>
                ))}
              </div>

              {/* Security and Compliance Solutions */}
              <p className="partner-title mt-3">
                <b>{title_2 || "Security and Compliance Solutions"}</b>
              </p>
              <p className="sub_desc ">{title_2_content}</p>

              {/* Logos for Security and Compliance Solutions */}
              <div className="list partner-images">
                {formattedDownLogos.map((logo, index) => (
                  <div key={index} className={`para partner-${index + 1}`}>
                    <img
                      src={logo}
                      alt={`Security Partner ${index + 1}`}
                      className="partner-image"
                      onError={(e) => (e.target.src = "/fallback/image.jpg")}
                    />
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* Right Column */}
          <Col md={12} lg={6}>
            <div className="image partnerimage">
              <img
                src={fullImage}
                alt="Cloud solutions overview"
                className="partner-main-image"
                onError={(e) => (e.target.src = "/fallback/image.jpg")}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Partner;


